module.exports = __webpack_public_path__ + "img/main-logo.736c8b46.svg";